class TechnicalLibrary extends HTMLElement {
  connectedCallback() {
    this.search = this.querySelector('[data-library-search]');
    this.toggle = this.querySelector('[data-library-toggle]');
    this.nav = this.querySelector('[data-library-nav]');
    this.toc = this.querySelector('[data-library-toc]');

    if (this.search && this.nav) {
      this.search.addEventListener('input', () => this.filterNavigation());
    }

    if (this.toggle) {
      this.toggle.addEventListener('click', () => {
        const open = this.classList.toggle('is-nav-open');
        this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    this.buildTableOfContents();
  }

  filterNavigation() {
    const term = this.search.value.trim().toLowerCase();
    this.nav.querySelectorAll('li').forEach((item) => {
      const ownLabel = item.querySelector(':scope > a, :scope > details > summary');
      const matches = !term || (ownLabel && ownLabel.textContent.toLowerCase().includes(term));
      const childMatches = Array.from(item.querySelectorAll('a, summary'))
        .some((link) => !term || link.textContent.toLowerCase().includes(term));
      item.hidden = !(matches || childMatches);
      if (term && childMatches) item.querySelector(':scope > details')?.setAttribute('open', '');
    });
  }

  buildTableOfContents() {
    if (!this.toc) return;
    const content = this.querySelector('[data-library-content]');
    if (!content) return;
    const headings = Array.from(content.querySelectorAll('h2, h3'));
    if (!headings.length) {
      this.toc.hidden = true;
      return;
    }

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `section-${index + 1}`;
      const item = document.createElement('li');
      item.dataset.level = heading.tagName.substring(1);
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      this.toc.appendChild(item);
    });
  }
}

if (!customElements.get('technical-library')) {
  customElements.define('technical-library', TechnicalLibrary);
}
